import { NativeIterationBounds, ScalarFieldProducer } from './scalar-field';
import { BufferedScalarField } from './scalar-field-impl';
import { UTM, Hemisphere } from '../map/projection';

interface ParseResult {
    rowOrientation: boolean,  //the data flows in rows instead of columns
    start: {
        x: number,
        y: number
    },
    step: {
        x: number,
        y: number
    },
    size: {
        x: number,
        y: number
    },
    range: {
        min: number,
        max: number
    },
    values: number[]
//    value: number 
}

export const XYZFile: ScalarFieldProducer = {
        getScalarFields: ( input: string) => {
            let content:string = <string>input;
        const startTime = performance.now();
        let lines = content.split('\n');

        
        let l0 = lines[0].split(';');
        let origin = { x: parseFloat(l0[0]), y: parseFloat(l0[1]) };
        let zone = parseInt( l0[2] );
        let hemisphere:Hemisphere = l0[3] === 'N' ? Hemisphere.North : Hemisphere.South;
        
        let title = lines[1];
        
        let headers = lines[2].split(';');
        
        let properties = lines[3].split(';');
        const minValue = parseFloat(properties[0]);
        const maxValue = parseFloat(properties[1]);
        const count = parseFloat(properties[2]); //only one value given here so we have to assume horizontal and vertical resolution is the same
        //however we totally ignore thes properties and will detect them from the data set.
        
        let values = lines.slice(4).filter(dataLine => dataLine.trim().length > 0).map( dataLine => dataLine.split(' ').map( (value, index) => parseFloat(value) ) );
        
        const rowOrientation = (values[1][0] - values[0][0]) !== 0;  //the data flows in rows instead of columns
        
        let data:ParseResult = {
                rowOrientation: rowOrientation,  //the data flows in rows instead of columns
                start: {
                    x:values[0][0],
                    y:values[0][1]
                },
                step: {
                    x:0,
                    y:0
                },
                size: {
                    x: 0,
                    y: 0
                },
                range: {
                    min: undefined,
                    max: undefined
                },
                values: []
              //  value: undefined 
                
        };
        
        const reducer = ( accu: ParseResult, dataRow: number[], i: number, v:number[][] ) => {
            let dX = i>0 ? dataRow[0] - v[i-1][0] : 0;
            let dY = i>0 ? dataRow[1] - v[i-1][1] : 0;
            accu.step.x = (accu.step.x === 0 && dX !== 0) ? dX : accu.step.x;
            accu.step.y = (accu.step.y === 0 && dY !== 0) ? dY : accu.step.y;
            
            if(accu.rowOrientation){
                accu.size.x += (i===0 ? 1 : accu.step.y===0 ? 1 : 0); 
                accu.size.y += (i===0 ? 1 : dY!==0 ? 1 : 0);
            }else{
                accu.size.y += (i===0 ? 1 : accu.step.x===0 ? 1 : 0); 
                accu.size.x += (i===0 ? 1 : dX!==0 ? 1 : 0);
            }
            
            accu.values.push(dataRow[2]);
            accu.range.min = accu.range.min === undefined ? dataRow[2] : Math.min( accu.range.min, dataRow[2] ); 
            accu.range.max = accu.range.max === undefined ? dataRow[2] : Math.max( accu.range.max, dataRow[2] ); 
            return accu;
        } 
        data = values.reduce( reducer, data);
        
        const utm = UTM.get(zone, hemisphere);
        //we need to get our bearings straight. What is up what is down? What is left what is right?
        let nativeIterationBounds :NativeIterationBounds ={
                rowOrientation: data.rowOrientation,
                x: { min: undefined, max: undefined, step: undefined, count: data.size.x },
                y: { min: undefined, max: undefined, step: undefined, count: data.size.y }
        }
    
        nativeIterationBounds.x.step = Math.abs(data.step.x);//always positive
        nativeIterationBounds.y.step = -1 * Math.abs(data.step.y);//always negative
        nativeIterationBounds.x.min = data.step.x > 0 ? data.start.x : data.start.x + (data.size.x-1) * (data.step.x);
        nativeIterationBounds.y.max = data.step.y < 0 ? data.start.y : data.start.y + (data.size.y-1) * (data.step.y);
        nativeIterationBounds.x.max = nativeIterationBounds.x.min + (data.size.x - 1) * nativeIterationBounds.x.step;
        nativeIterationBounds.y.min = nativeIterationBounds.y.max + (data.size.y - 1) * nativeIterationBounds.y.step;

        let sf = new BufferedScalarField( title, utm, nativeIterationBounds, {start:undefined, end:undefined}, data.step, data.values.concat([]), 0.0, title, headers[2] );
        
        const endTime = performance.now();
        //console.log(`XYZ file parsed in ${endTime-startTime}ms and contains ${content.length} bytes.`);
        
        return [ sf ];
        }
}
